import ArtistSearchBaseController from "./artist_search_base"

export default class extends ArtistSearchBaseController {
  // Implementation of abstract methods from base class
  getCallingControllerType() {
    return "track_featuring"
  }

  getHiddenInputName() {
    return "track[featuring_artist_ids][]"
  }

  getHiddenInputId(artistId) {
    return `track_featuring_artist_${artistId}`
  }
}
